import { render, staticRenderFns } from "./ThirdSection.vue?vue&type=template&id=72167b3a&scoped=true&"
import script from "./ThirdSection.vue?vue&type=script&lang=js&"
export * from "./ThirdSection.vue?vue&type=script&lang=js&"
import style0 from "./ThirdSection.vue?vue&type=style&index=0&id=72167b3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72167b3a",
  null
  
)

export default component.exports